module.exports = __webpack_public_path__ + "img/2023big33.54249cd6.png";